import { create } from 'zustand';
import ServiceTabelas from '@/services/ServiceTabelas';
import { notify } from '@/stores/useToast';

type Parametro = any;

interface State {
  lista: Parametro[];
  carregando: boolean;
  buscar: () => Promise<void>;
}

export const useParametrosStore = create<State>((set) => ({
  lista: [],
  carregando: false,
  async buscar() {
    set({ carregando: true });
    try {
      const { data } = await ServiceTabelas.parametrosAnalise();
      set({ lista: Array.isArray(data) ? data : (data.content ?? []) });
    } catch {
      notify.error('Erro ao buscar parâmetros de análise.');
    } finally {
      set({ carregando: false });
    }
  },
}));
